export default "__VITE_ASSET__1ba39e1a__"